import React from "react";
import times from "lodash/times";
import { withTranslation } from "react-i18next";
import Modal from "../../../parts/modal";
import ToolTip from "../../../parts/tooltip";
import GroupCheckbox from "../../../parts/inputs/group-checkbox";
import NumberInput from "../../../parts/inputs/number-input";
import { RillContext } from "../../../rill/RillReact/share/base";

class ProgramSettingsModal extends React.Component {
  constructor(props, ctx) {
    super(props);
    this.state = {
      maxFrequency: ctx.locals.query.sessionsPerWeek || 1,
    };
    this.handleLiftFrequencyChange = this.handleLiftFrequencyChange.bind(this);
    this.liftFrequencyOptions = this.liftFrequencyOptions.bind(this);
  }

  handleLiftFrequencyChange(e) {
    this.setState({ maxFrequency: e.target.value });
  }

  liftFrequencyOptions(maxFrequency) {
    // Number of lift frequency options is the same as the number of sessions per week
    return times(parseInt(maxFrequency) + 1, (ind) => (
      <option key={ind}>{ind}</option>
    ));
  }

  render() {
    const {
      locals: { query, activeUser },
    } = this.context;
    const { t } = this.props;
    const isPremiumCoach = false;
    const isCoach = activeUser.permissions?.includes("coach");
    return (
      <form
        action={`/actions/cycle/${query.cycleId}/?proxyAthlete=${query.athlete}`}
        method="POST"
        data-noreset
      >
        <Modal width="600px">
          <div className="head border-divider">
            <h2 className="alt">{t("programSettings.title")}</h2>
          </div>

          <div className="body">
            <div
              className={`Program-Settings ${
                isPremiumCoach ? "alt-coach" : ""
              }`}
            >
              <div className="group">
                <div className="label">{t("programSettings.programName")}</div>
                <input
                  name="name"
                  className="text-input"
                  placeholder={t("programSettings.programNamePlaceholder")}
                />
              </div>

              <div className="group">
                <div className="label">{t("programSettings.goals")}</div>
                <input
                  name="goals"
                  className="text-input"
                  placeholder={t("programSettings.goalsPlaceholder")}
                />
              </div>

              <div className="group">
                <div className="columns">
                  <div className="column alt-info" data-col="1/2">
                    <div className="label">
                      {t("programSettings.numberOfWeeks")}
                    </div>
                    <NumberInput
                      isPremiumCoach={isPremiumCoach}
                      name="numberOfWeeks"
                      className="text-input number-input"
                    />
                    {!isPremiumCoach && (
                      <ToolTip
                        id="number-of-weeks"
                        body={t("programSettings.numberOfWeeksTooltip")}
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    )}
                    {isPremiumCoach && (
                      <ToolTip
                        id="number-of-weeks"
                        body={t("programSettings.premiumWeeksTooltip")}
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    )}
                  </div>

                  <div className="column alt-info" data-col="1/2">
                    <div className="label">
                      {t("programSettings.sessionsPerWeek")}
                    </div>
                    <select
                      name="sessionsPerWeek"
                      className="select-input"
                      defaultValue={this.state.sessionsPerWeek || null}
                      onChange={(e) => this.handleLiftFrequencyChange(e)}
                    >
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                      <option value={4}>4</option>
                      <option value={5}>5</option>
                      <option value={6}>6</option>
                      <option value={7}>7</option>
                    </select>

                    {!isPremiumCoach && (
                      <ToolTip
                        id="sessions-per-week"
                        body={t("programSettings.sessionsPerWeekTooltip")}
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    )}
                    {isPremiumCoach && (
                      <ToolTip
                        id="sessions-per-week"
                        body={t("programSettings.sessionsPerWeekTooltip")}
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    )}
                  </div>
                </div>
              </div>

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="label">{t("programSettings.difficulty")}</div>
                  <ul className="Radio-Group Difficulty-Group" data-cols="1/3">
                    <li>
                      <label className="radio-input">
                        <input name="difficulty" type="radio" value="Novice" />
                        <span className="radio" />
                        <span className="text">
                          {t("programSettings.novice")}
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="radio-input">
                        <input
                          name="difficulty"
                          type="radio"
                          value="Intermediate"
                        />
                        <span className="radio" />
                        <span className="text">
                          {t("programSettings.intermediate")}
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="radio-input">
                        <input
                          name="difficulty"
                          type="radio"
                          value="Advanced"
                        />
                        <span className="radio" />
                        <span className="text">
                          {t("programSettings.advanced")}
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
              )}

              {(isCoach || isPremiumCoach) && (
                <GroupCheckbox
                  name="liftPriority"
                  title={t("programSettings.liftPriority")}
                  checkboxes={[
                    {
                      html: t("programSettings.squat"),
                      value: "Squat",
                    },
                    {
                      html: t("programSettings.bench"),
                      value: "Bench",
                    },
                    {
                      html: t("programSettings.deadlift"),
                      value: "Deadlift",
                    },
                  ]}
                  inputGroupClassName="Check-Group"
                />
              )}

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("programSettings.squatFrequency")}
                      </div>
                      <select name="squatFrequency" className="select-input">
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("programSettings.benchFrequency")}
                      </div>
                      <select name="benchFrequency" className="select-input">
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("programSettings.deadliftFrequency")}
                      </div>
                      <select name="deadliftFrequency" className="select-input">
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">{t("programSettings.volume")}</div>
                      <select name="volume" className="select-input">
                        <option value="">
                          {t("programSettings.chooseVolume")}
                        </option>
                        <option value="High">{t("programSettings.high")}</option>
                        <option value="Medium">
                          {t("programSettings.medium")}
                        </option>
                        <option value="Low">{t("programSettings.low")}</option>
                      </select>
                    </div>

                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("programSettings.intensity")}
                      </div>
                      <select name="intensity" className="select-input">
                        <option value="">
                          {t("programSettings.chooseIntensity")}
                        </option>
                        <option value="High">{t("programSettings.high")}</option>
                        <option value="Medium">
                          {t("programSettings.medium")}
                        </option>
                        <option value="Low">{t("programSettings.low")}</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="columns">
                    <div className="column alt-info" data-col="1/1">
                      <div className="label">
                        {t("programSettings.weeksOutFromCompetition")}
                      </div>
                      <select
                        name="weeksToCompetition"
                        className="select-input"
                      >
                        <option value="">
                          {t("programSettings.chooseWeeks")}
                        </option>
                        <option value="four">
                          {t("programSettings.fourWeeks")}
                        </option>
                        <option value="eight">
                          {t("programSettings.eightWeeks")}
                        </option>
                        <option value="twelve">
                          {t("programSettings.twelveWeeks")}
                        </option>
                        <option value="more">
                          {t("programSettings.moreThanTwelveWeeks")}
                        </option>
                      </select>
                      <ToolTip
                        id="weeks-out-from-competition"
                        body={t("programSettings.weeksOutFromCompetitionTooltip")}
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    </div>
                  </div>
                </div>
              )}

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("programSettings.equippedLifting")}
                      </div>
                      <ul className="Radio-Group" data-cols="1/2">
                        <li>
                          <label className="radio-input">
                            <input
                              name="isEquippedLifting"
                              type="radio"
                              value="true"
                            />
                            <span className="radio" />
                            <span className="text">
                              {t("programSettings.yes")}
                            </span>
                          </label>
                        </li>
                        <li>
                          <label className="radio-input">
                            <input
                              name="isEquippedLifting"
                              type="radio"
                              value="false"
                              defaultChecked
                            />
                            <span className="radio" />
                            <span className="text">
                              {t("programSettings.no")}
                            </span>
                          </label>
                        </li>
                      </ul>
                    </div>

                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("programSettings.equipmentRequired")}
                      </div>
                      <select name="equipmentRequired" className="select-input">
                        <option value="">
                          {t("programSettings.chooseEquipment")}
                        </option>
                        <option value="Barbell Only">
                          {t("programSettings.barbellOnly")}
                        </option>
                        <option value="Barbell / Dumbbells">
                          {t("programSettings.barbellDumbbells")}
                        </option>
                        <option value="Barbell / Dumbbells / Cables">
                          {t("programSettings.barbellDumbbellsCables")}
                        </option>
                        <option value="Full Gym Capability">
                          {t("programSettings.fullGymCapability")}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              <div className="group">
                <div className="label">
                  {isPremiumCoach
                    ? t("programSettings.description")
                    : t("programSettings.notes")}
                </div>
                <textarea
                  name="description"
                  className="textarea-input"
                  placeholder={t("programSettings.descriptionPlaceholder", {
                    type: isPremiumCoach
                      ? t("programSettings.aDescription")
                      : t("programSettings.someNotes"),
                  })}
                ></textarea>
              </div>
            </div>
          </div>

          <div className="foot">
            <div className="columns">
              <div className="column" data-col="1/2">
                <a className="button alt" href="/actions/refresh?modal=">
                  {t("programSettings.cancel")}
                </a>
              </div>

              <div
                className="column mobile-hidden"
                data-col="1/2"
                style={{ textAlign: "right" }}
              >
                <button type="submit" className="button-input">
                  {t("programSettings.next")}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

ProgramSettingsModal.contextType = RillContext;

export default withTranslation("coaching-portal")(ProgramSettingsModal);
